import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { authSlice } from "./slice/auth";
import { notificationSlice } from "./slice/notifications";
import { settingSlice } from "./slice/settings";
export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        notification: notificationSlice.reducer,
        settings: settingSlice.reducer
    },
    devTools: process.env.NODE_ENV !== 'production'
});
// Use `useAppDispatch` rather the untyped `useDispatch` from `react-redux`
export const useAppDispatch = useDispatch.withTypes();
// Use `useAppSelector` rather the untyped `useSelector` from `react-redux`
export const useAppSelector = useSelector.withTypes();
